// extracted by mini-css-extract-plugin
module.exports = {"menuSubTitle":"AboutSidebar_menuSubTitle__2mSBX","dropDownTitle":"AboutSidebar_dropDownTitle__dC2T2"};